<template>
  <div>
    <section
      id="topbar"
      v-show="this.$store.state.topbar_actions_visible"
      :class="environment"
    >
      <div id="back">
        <!-- <router-link class="name" @click="backAction" :to="formatUrl( back )">{{ 'back' | i18n}}</router-link> -->
        <div class="name" @click="backAction">
          <img src="/img/back-arrow.svg" />
        </div>
      </div>
      <div class="title">{{ $t(page) }}</div>

      <!-- <div id="breadcrumbs">
				<div v-for="(item, index) in breadcrumbs" class="item">
					<router-link class="name" :to="formatUrl( item.url )">{{item.label | i18n}}</router-link>
				</div>

			</div> -->
      <div id="breadcrumbs">
        <div
          v-for="(item, index) in submenus"
          class="item"
          :class="{ selected: item.selected }"
          :key="index"
        >
          <router-link class="name" :to="formatUrl(item.url)">{{
            item.label | i18n
          }}</router-link>
        </div>
      </div>
      <div id="actions" v-show="this.$store.state.topbar_buttons_visible">
        <router-link
          v-if="
            actions.main.url &&
            (typeof actions.main.visible === 'undefined' ||
              actions.main.visible) &&
            (!isEventSelected ||
              typeof actions.main.only_global === 'undefined' ||
              !actions.main.only_global)
          "
          class="button"
          @click="showOverlay"
          :to="formatUrl(actions.main.url)"
          ><div class="item" id="main">
            {{ actions.main.label | i18n }}
          </div></router-link
        >
        <div
          v-else-if="
            (typeof actions.main.visible === 'undefined' ||
              actions.main.visible) &&
            (!isEventSelected ||
              typeof actions.main.only_global === 'undefined' ||
              !actions.main.only_global)
          "
          class="button"
          @click="fnAction(actions.main.action, actions.main.type)"
        >
          <div class="item" id="main">{{ actions.main.label | i18n }}</div>
        </div>
        <div
          class="item more"
          v-if="actions_other.length > 0"
          @click="showOtherActions"
        ></div>

        <div v-if="show_import" id="imports">
          <div v-if="actions.main.type == 'excel'">
            <label>{{ $t("finances.import.kind") }}</label>
            <select id="type_file">
              <option value="1" selected>TPV</option>
              <option value="0">{{ $t("finances.import.transfer") }}</option>
            </select>
          </div>
          <button
            class="blue plus_button"
            v-on:click.prevent="$refs.file.click()"
          >
            {{ $t("finances.import.select") }}
          </button>
          <input
            id="file"
            @change="changeFile($event)"
            ref="file"
            style="display: none"
            v-bind:accept="
              actions.main.type == 'excel'
                ? '.csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : '*'
            "
            type="file"
          />
          <span class="error" v-if="fileError">{{
            $t("finances.import.error")
          }}</span>
          <span id="fileSelected" v-if="file && !fileError">{{
            file.name
          }}</span>
          <button
            class="green"
            :style="[file ? { display: 'block' } : { display: 'none' }]"
            @click="fnImport()"
          >
            {{ $t("finances.import.save") }}
          </button>
        </div>
      </div>

      <div
        class="actions-other"
        v-if="show_actions_other && actions_other.length > 0"
      >
        <div
          v-for="(item, index) in actions_other"
          class="item"
          :key="index"
          @click="fnAction(item.action, item.type, true)"
        >
          {{ item.label | i18n }}
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["fileError", "page_name"],
  data() {
    return {
      show_import: false,
      show_create_sanction: false,
      show_actions_other: false,
      current_filters_values: {
        ...this.$store.getters["navigation/getCurrentPage"].default_top_filters,
      },
      file: false,
      environment: process.env.VUE_APP_ENVIRONMENT,
    };
  },
  computed: {
    breadcrumbs() {
      var sCurrentPage = this.$store.state.current_page;
      var ROUTER = this.$store.getters["navigation/getRouting"];
      var aBreadCrumbs = [];
      var bEnd = false;

      while (!bEnd) {
        var page = { ...ROUTER[sCurrentPage] };
        if (this.$store.state.event_selected) {
          page.url =
            "/event/" +
            this.$route.params.event +
            (page.url == "/" ? "" : page.url);
        }
        aBreadCrumbs.push(page);
        if (ROUTER[sCurrentPage].parent_id == -1) {
          bEnd = true;
        }

        sCurrentPage = ROUTER[sCurrentPage].parent_id;
      }

      return aBreadCrumbs.reverse();
    },

    submenus() {
      var sCurrentPage = this.$store.state.current_page;
      var ROUTER = this.$store.getters["navigation/getRouting"];
      var aSubMenus = [];
      if (typeof ROUTER[sCurrentPage].submenus !== "undefined") {
        var submenus = [...ROUTER[sCurrentPage].submenus];

        var self = this;
        submenus.forEach((sub) => {
          if (
            self.$store.getters.isEventSelected &&
            (typeof sub.only_event === "undefined" ||
              (sub.only_event && self.$store.getters.isEventSelected))
          ) {
            aSubMenus.push({
              label: sub.label,
              url:
                "/event/" +
                self.$route.params.event +
                (sub.url == "/" ? "" : sub.url),
              selected: typeof sub.selected !== "undefined" && sub.selected,
            });
          } else if (
            !self.$store.getters.isEventSelected &&
            (typeof sub.only_event === "undefined" || !sub.only_event)
          ) {
            aSubMenus.push({
              label: sub.label,
              url: sub.url,
              selected: typeof sub.selected !== "undefined" && sub.selected,
            });
          }
        });
      }

      return aSubMenus;
    },

    back() {
      var sCurrentPage = this.$store.getters.getCurrentPage;
      var ROUTER = this.$store.getters["navigation/getRouting"];
      var oCurrentPage = ROUTER[sCurrentPage];
      var oPrevPage = ROUTER[oCurrentPage.parent_id];

      // if( this.$store.getters.isEventSelected ){
      // 	return '/event/' + this.$route.params.event + ( ( oPrevPage.url == '/' )? '' : oPrevPage.url );
      // }
      return oPrevPage.url;
    },

    page() {
      return this.$store.getters["navigation/getCurrentPage"].label;
    },

    actions() {
      return this.$store.getters["navigation/getCurrentPage"].actions;
    },

    actions_other() {
      var aActions =
        this.$store.getters["navigation/getCurrentPage"].actions.other;
      var aActionsVisible = [];

      var self = this;
      for (var k in aActions) {
        var action = aActions[k];
        if (
          self.$store.getters.isEventSelected &&
          (typeof action.only_global === "undefined" || !action.only_global)
        ) {
          aActionsVisible.push(action);
        } else if (
          !self.$store.getters.isEventSelected &&
          (typeof action.only_event === "undefined" || !action.only_event)
        ) {
          aActionsVisible.push(action);
        }

        // if( ( typeof action.only_event === 'undefined' || !action.only_event || self.$store.getters.isEventSelected || typeof action.only_global === 'undefined' ) && ( !action.only_global || ( action.only_global && !self.$store.getters.isEventSelected ) ) ){
        // 	aActionsVisible.push( action );
        // }
        // else if( typeof action.only_global === 'undefined' || !action.only_global || ( action.only_global && !self.$store.getters.isEventSelected ) ){
        // 	aActionsVisible.push( action );
        // }
      }
      return aActionsVisible;
    },

    isEventSelected() {
      return this.$store.getters.isEventSelected;
    },

    is_visible_topfilters() {
      this.$store.commit("setTopFiltersVisible", this.top_filters.length > 0);
      return this.top_filters.length > 0;
    },

    top_filters() {
      if (
        typeof this.$store.getters["navigation/getCurrentPage"].top_filters ===
        "undefined"
      ) {
        return [];
      }
      return [...this.$store.getters["navigation/getCurrentPage"].top_filters];
    },
  },
  methods: {
    formatUrl(url) {
      var cp_url = url;
      var regexp = new RegExp(/\/\:([a-zA-Z0-9_]*)/, "gi");
      var params = cp_url.match(regexp);
      if (params) {
        for (var i = 0; i < params.length; i++) {
          var param = params[i].replace(/\//g, "").replace(":", "");
          cp_url = cp_url.replace("\:" + param, this.$route.params[param]);
        }
      }

      if (
        typeof this.$route.params.event !== "undefined" &&
        this.$route.params.event != null
      ) {
        cp_url =
          "/event/" +
          this.$route.params.event +
          cp_url.replace("/event/" + this.$route.params.event, "");
      }

      return cp_url;
    },

    fnAction(action, type, bChangeVisibleOtherActions) {
      if (bChangeVisibleOtherActions) {
        this.show_actions_other = !this.show_actions_other;
      }
      if (type == "excel" || type == "file") {
        this.show_import = !this.show_import;
      }
      // console.log( action, type );
      // this.$emit( action, type );
      this.$emit("action", { action: action, params: type });
    },

    fnImport() {
      var data = {
        file: this.$refs.file.files[0],
      };
      if (this.actions.main.type == "excel") {
        var type = document.getElementById("type_file").value;
        if (type) {
          data.type = type;
        }
      }

      this.$emit("action", { action: "import", params: data });
    },
    changeFile(event) {
      this.$emit("changeFileError", false);
      this.file = event.target.files[0];
    },

    getOptions(options, filter) {
      if (typeof options === "string") {
        var aOptions = [];
        var values = this.$store.getters[options]();
        aOptions.push({ value: -1, text: filter.label });
        for (var i in values) {
          var value = values[i];
          aOptions.push({ value: value.id, text: value.name });
        }

        return aOptions;
      } else {
        return options;
      }
    },

    showOverlay() {
      this.$overlay.loading();
    },

    backAction() {
      var self = this;
      var callbackPage = this.formatUrl(this.back);
      self.$emit("action", { action: "destroy" });
      this.$store
        .dispatch("navigation/backPage", callbackPage)
        .then(function () {
          // self.$emit( "destroy" )
        });
    },

    showOtherActions() {
      if (this.show_actions_other) {
        this.$store.commit("setOverlayVisible", false);
      } else this.$store.commit("setOverlayVisible", true);

      this.show_actions_other = !this.show_actions_other;
    },

    destroyElement() {
      this.$destroy();
    },
  },
  created() {
    var self = this;
  },

  watch: {
    current_filters_values: {
      handler(val) {
        var filters = { ...this.current_filters_values };
        this.$store.commit("navigation/setCurrentTopFilters", {
          page: this.$store.getters.getCurrentPage,
          filters: filters,
        });

        var oFilters = {};
        for (var i in filters) {
          var filter = filters[i];
          for (var j in this.top_filters) {
            if (
              i == this.top_filters[j].param &&
              filter != this.top_filters[j].current_value
            ) {
              oFilters[i] = filter;
            }
          }
        }
        // this.$emit( 'applyFilters', ( ( Object.keys( oFilters ).length > 0 )? oFilters : false ) );
        this.$emit("action", {
          action: "applyFilters",
          params: Object.keys(oFilters).length > 0 ? oFilters : false,
        });
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#topbar {
  height: 50px;
  width: 100%;
  top: 60px;
  position: fixed;
  // overflow: hidden;
  padding: 0 10px;
  border-bottom: 1px solid #ddd;
  z-index: $z-topbar;
  background-color: #eee;

  &.development {
    top: calc(60px + #{$height-development});
  }

  .title {
    float: left;
    font-size: 18px !important;
    font-weight: bold;
    text-transform: uppercase;
    margin-right: 10px;
    padding: 18px 5px;
    color: #0d122d;
    font-family: $text-bold;
  }

  #breadcrumbs {
    display: inline-block;
    float: left;

    .item {
      float: left;
      margin: 0 10px;
      height: 50px;
      padding: 15px 5px;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        border-bottom: 3px solid #0d122d;
      }

      &.selected {
        border-bottom: 3px solid #0d122d;

        .name {
          font-weight: bold;
        }
      }

      .name {
        text-decoration: none;
        color: #333;
        line-height: 25px;
      }
    }
  }

  #back {
    display: inline-block;
    float: left;

    padding: 12.5px 5px;
    font-weight: lighter;

    div {
      font-size: 14px;
      line-height: 25px;
      color: #aaa;
      background-size: 10px;
      background-repeat: no-repeat;
      background-position: left center;
      padding: 1px;
      width: 30px;
      height: 30px;
      cursor: pointer;
      border-radius: 5px;
      background-color: white;
      overflow: hidden;
      text-align: center;

      img {
        width: 25px;
        height: 25px;
      }
    }
  }

  #imports {
    padding: 10px 25px;
    position: fixed;
    width: 200px;
    top: 100px;
    background-color: white;
    border: 2px solid;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    select {
      background-color: #ddd;
      border: 1px solid #000;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
      padding: 5px;
      width: 100%;
      margin-bottom: 15px;
      background-image: linear-gradient(45deg, transparent 50%, gray 50%),
        linear-gradient(135deg, gray 50%, transparent 50%),
        linear-gradient(to right, #ccc, #ccc);
      background-position: calc(100% - 20px) calc(0.8em + 0px),
        calc(100% - 15px) calc(0.8em + 0px);
      background-size: 5px 5px, 5px 5px, 1px 1.5em;
      background-repeat: no-repeat;
    }

    button {
      height: 35px;
      padding: 8px 20px;
      padding-left: 35px;
      text-align: center;
      margin-right: 15px;
      border-radius: 3px;
      font-size: 12px;
      width: 100%;
      text-transform: uppercase;
      color: #fff;
      cursor: pointer;
      background-size: 15px;
      margin-bottom: 15px;
    }
    .plus_button {
      background: url("/img/add.svg") no-repeat left 10px center;
      background-size: 15px;
    }
    .blue {
      background-color: #172654;

      &:hover {
        background-color: #253554;
      }
    }
    .green {
      background-color: #8bc34a;
      &:hover {
        background-color: #4caf50;
      }
    }
    //display: none;
  }

  #imports:before {
  }

  #actions {
    float: right;
    padding: 9px;

    .button {
      display: inline;
    }

    .item {
      padding: 15px;
      display: inline-block;
      float: left;

      &#main {
        height: 35px;
        padding: 8px 20px;
        padding-left: 35px;
        text-align: center;
        margin-right: 10px;
        border-radius: 3px;
        font-size: 12px;
        text-transform: uppercase;
        color: #333;
        cursor: pointer;
        background: url("/img/add_b.svg") no-repeat left 10px center #ffc107;
        border: 0px solid #ffc107;
        background-size: 15px;

        &:hover {
          background-color: #bc8e05;
        }
      }
      &.more {
        background: url("/img/menu_b.svg") no-repeat center;
        background-size: 25px;
        border: 1px solid #ccc;
        padding: 10px;
        height: 35px;
        width: 50px;
        background-color: #fff;
        cursor: pointer;
        border-radius: 3px;
      }
    }
  }

  .actions-other {
    position: fixed;
    top: calc(#{$header-height} + #{$topbar-height} - 1px);
    background: #fff;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #fff;
    z-index: $z-menu-aux;
    right: 0;
    width: 200px;

    .item {
      width: 100%;
      float: left;
      text-align: center;
      line-height: 35px;
      cursor: pointer;

      &:not(:last-child) {
        border-bottom: 1px solid #ddd;
      }

      &:hover {
        background-color: #ccc;
      }
    }
  }
}

#topfilters {
  height: 50px;
  width: 100%;
  top: 110px;
  position: fixed;
  overflow: hidden;
  padding: 0 10px;
  border-bottom: 1px solid #ddd;
  z-index: $z-topbar;
  background-color: #fff;

  .content_filters {
    width: 100%;

    .filter {
      max-width: 400px;
      margin: 0 auto;
      height: 50px;

      .title {
        width: fit-content;
        float: left;
      }
      .value {
        width: fit-content;
        float: right;
        margin-left: 30px;
      }
    }
  }
}

#fileSelected {
  margin-top: -10px;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 10px;
  border: 1px solid green;
  padding: 3px;
}

.error {
  margin-top: -10px;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 10px;
  padding: 3px;
  color: red;
}
</style>
